import { MockHandler } from '@gv/triage-components';

import { URL } from 'api/constants';

const cities: string[] = [
  'New York City',
  'Chicago',
  'San Francisco',
  'Seattle',
  'New Orleans',
  'Portland',
  'Los Angeles',
  'San Diego',
  'Boston',
  'Honolulu',
  'Austin',
  'Washington',
  'Cleveland',
  'Las Vegas',
  'Kansas City',
  'Miami',
  'Memphis',
  'Denver',
  'Bridgeport',
  'Savannah',
];

const searchFilter = (array: string[], search?: string) => {
  if (!search) {
    return array;
  }

  return array.filter((item) =>
    item.toLocaleLowerCase().includes(search.toLocaleLowerCase())
  );
};

export const citiesApiHandlers: MockHandler[] = [
  {
    method: 'get',
    url: URL.GET_CITIES,
    responseFunc: ({ data }) => searchFilter(cities, data?.search),
  },
];
